import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-formulario-entidade",
  templateUrl: "./formulario-entidade.component.html",
  styleUrls: ["./formulario-entidade.component.scss"],
})
export class FormularioEntidadeComponent {
  @Input() formEntity: FormGroup;
  @Input() tableDdi: any[] = [];
  @Input() nextDisabled: boolean = false;
  @Input() mostrarBotaoVoltar: boolean = false;
  @Input() titulo: string = '3 - Dados da Entidade';
  @Output() voltar = new EventEmitter<void>();

  @Output() efetuarCadastro = new EventEmitter<void>();

  //MASK
  maskTelefone(telefone: number) {
    if (this.codigoDdi.value == "+55") {
      if (telefone == 1) return "(00) 0000-0000";
      else return "(00) 0 0000-0000";
    } else return "000000000000000";
  }

  //GET & SETTER
  get tipoEntidade() {
    return this.formEntity.get("tipoEntidade");
  }

  get documentoIdentificadorCNPJ() {
    return this.formEntity.get("documentoIdentificador");
  }

  get razaoSocial() {
    return this.formEntity.get("razaoSocial");
  }

  get codigoDdi() {
    return this.formEntity.get("codigoDdi");
  }

  get telefone() {
    return this.formEntity.get("telefone");
  }

  get celular() {
    return this.formEntity.get("celular");
  }
}
